import { Spinner } from '@ui';

export function RoutePending() {
  return (
    <div className="grid h-full place-items-center p-6">
      <Spinner />
    </div>
  );
}
